import { useCallback, useRef } from "react";

export const useStableCallback = <
  // biome-ignore lint/suspicious/noExplicitAny: Generic type
  Callback extends (...args: any[]) => any,
>(
  callback: Callback
): ((...args: Parameters<Callback>) => ReturnType<Callback>) => {
  const callbackRef = useRef<Callback>(callback);
  callbackRef.current = callback;
  return useCallback((...args: Parameters<Callback>) => callbackRef.current(...args), []);
};
